// Справочник стёкол для алюминиевых перегородок (Stage 2).
// Держать в синхроне с kepler_back_new/order/service/partitionCatalog.js

export const DEFAULT_MAX_HEIGHT = 3320;

export const GLASS_CATALOG = [
  { name: "Прозрачное",                    group: "Прозрачное",    pricePerM2:  7000, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3320 },
  { name: "Прозрачное Бронзовое",          group: "Прозрачное",    pricePerM2:  9975, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3410 },
  { name: "Прозрачное Бронза чайная",      group: "Прозрачное",    pricePerM2:  9975, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2710 },
  { name: "Прозрачное Серое / Графит",     group: "Прозрачное",    pricePerM2:  9975, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3410 },
  { name: "Прозрачное Графит ТЕМНЫЙ",      group: "Прозрачное",    pricePerM2:  9975, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3410 },

  { name: "Матовое классическое",          group: "Матовое",       pricePerM2: 11025, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3320 },
  { name: "Матовое Бронзовое",             group: "Матовое",       pricePerM2: 15750, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3320 },
  { name: "Матовое Серое / Графит",        group: "Матовое",       pricePerM2: 15750, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3320 },

  { name: "Зеркало бронированное",         group: "Зеркало",       pricePerM2: 12600, canTemper: false, isMirror: true,  maxHeightWithoutDivider: 2710 },
  { name: "Зеркало высокое",               group: "Зеркало",       pricePerM2:  7500, canTemper: false, isMirror: true,  maxHeightWithoutDivider: 3320 },
  { name: "Зеркало двойное",               group: "Зеркало",       pricePerM2: 18900, canTemper: false, isMirror: true,  maxHeightWithoutDivider: 2710 },
  { name: "Зеркало Бронзовое",             group: "Зеркало",       pricePerM2: 16800, canTemper: false, isMirror: true,  maxHeightWithoutDivider: 2660 },
  { name: "Зеркало Серое",                 group: "Зеркало",       pricePerM2: 16800, canTemper: false, isMirror: true,  maxHeightWithoutDivider: 2660 },
  { name: "Зеркальная бронза",             group: "Зеркало",       pricePerM2: 10500, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2550 },

  { name: "Рифленое Прозрачное",           group: "Рифленое",      pricePerM2: 26250, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3410 },
  { name: "Рифленое Матовое",              group: "Рифленое",      pricePerM2: 29400, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3410 },
  { name: "Рифленое Бронзовое",            group: "Рифленое",      pricePerM2: 29400, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3410 },
  { name: "Рифленое Серое",                group: "Рифленое",      pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 3410 },

  { name: "Лакобель (цвет в ассортименте)", group: "Дизайнерское", pricePerM2: 20000, canTemper: false, isMirror: false, maxHeightWithoutDivider: 2360 },
  { name: "Волна Супермат",                group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Супермат Графит",               group: "Дизайнерское",  pricePerM2: 16800, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Супермат Черный",               group: "Дизайнерское",  pricePerM2: 16800, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Супермат Бронза",               group: "Дизайнерское",  pricePerM2: 16800, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Квадрат Прозрачный",            group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Квадрат Матовый",               group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Брошированная Бронза",          group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Брошированный Графит",          group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Текстиль Черный",               group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Текстиль Графит",               group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Текстиль Бронза",               group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Текстиль Бесцветный",           group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Вельвет Супермат",              group: "Дизайнерское",  pricePerM2: 19950, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Микролайн",                     group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Диор",                          group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Елочка прозрачное",             group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Вертикальная капля",            group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Волна крупная",                 group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Аквалайт",                      group: "Дизайнерское",  pricePerM2: 31500, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Черепашка",                     group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Микроквадрат",                  group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
  { name: "Волна мелкая выпуклая",         group: "Дизайнерское",  pricePerM2: 28350, canTemper: true,  isMirror: false, maxHeightWithoutDivider: 2910 },
];

export const LEGACY_GLASS_COLOR_ALIASES = {
  TRANSPARENT: "Прозрачное",
  GREY: "Прозрачное Серое / Графит",
  GRAPHITE: "Прозрачное Графит ТЕМНЫЙ",
};

const GLASS_INDEX = new Map(GLASS_CATALOG.map((g) => [g.name, g]));

export const resolveGlass = (glassColor) => {
  if (!glassColor) return null;
  const key = LEGACY_GLASS_COLOR_ALIASES[glassColor] || glassColor;
  return GLASS_INDEX.get(key) || null;
};

export const normalizeGlassColor = (glassColor) => {
  if (!glassColor) return glassColor;
  return LEGACY_GLASS_COLOR_ALIASES[glassColor] || glassColor;
};

export const INSTALLMENT_OPTIONS = [
  { value: "NONE", label: "Нет", percent: 0 },
  { value: "KASPI", label: "Kaspi", percent: 12 },
  { value: "HALYK", label: "Halyk", percent: 18 },
];

export const DESIGNER_DEFAULT_PERCENT = 10;
export const VAT_DEFAULT_PERCENT = 16;

export const OPENING_CONFIGS = [
  { sections: 1, label: "1 секция Magic" },
  { sections: 1, label: "1 секция перед проемом" },
  { sections: 1, label: "1 секция в пенал" },
  { sections: 2, label: "2 секции в проем" },
  { sections: 2, label: "2 секции перед проемом" },
  { sections: 2, label: "2 секции перед проемом (1 стык)" },
  { sections: 2, label: "2 секции в пенал (каскад)" },
  { sections: 3, label: "3 секции в проем (каскад)" },
  { sections: 3, label: "3 секции в проем (1+2)" },
  { sections: 3, label: "3 секции в проем (1 стык)" },
  { sections: 3, label: "3 секции (каскад) в пенал" },
  { sections: 4, label: "4 секции в проем (каскад)" },
  { sections: 4, label: "4 секции в проем (2+2) + 1 стык" },
  { sections: 4, label: "4 секции (каскад) в пенал" },
  { sections: 5, label: "5 секций в проем (каскад)" },
  { sections: 5, label: "5 секций (каскад) в пенал" },
  { sections: 6, label: "6 секций в проем (каскад)" },
  { sections: 6, label: "6 секций в проем (3+3)+1 стык" },
];

export const SECTION_WIDTH_MIN = 600;
export const SECTION_WIDTH_MAX = 1100;

export const getGlassDimensions = (openingHeight, openingWidth, sectionsCount) => {
  if (!openingHeight || !openingWidth || !sectionsCount) {
    return { glassHeight: 0, glassWidth: 0, glassCount: 0 };
  }
  return {
    glassHeight: openingHeight - 117,
    glassWidth: (openingWidth - 17) / sectionsCount,
    glassCount: sectionsCount,
  };
};
